module.exports = __webpack_public_path__ + "img/mercedes-benz-logo-desktop.d3b5bb2b.png";